"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firebaseRealtimeDbGetRootPath = ({ projectId, isDevelopment, }) => {
    const dbName = isDevelopment ? 'dataDevelopment' : 'data';
    return `projects/${projectId}/${dbName}`;
};
exports.default = firebaseRealtimeDbGetRootPath;
